module.exports = __webpack_public_path__ + "fonts/icomoon.c90e0290.ttf";